module.exports = __webpack_public_path__ + "img/joy-icon.d668b81d.png";